// src/components/BlackFridayCountdown.js
import React, { useEffect, useState } from "react";
import { Typography, Paper, useTheme } from "@mui/material";
import { differenceInSeconds } from "date-fns";
import { formatInTimeZone } from "date-fns-tz";

// California timezone
const TIMEZONE = "America/Los_Angeles";

// helper to get Black Friday (4th Friday in November)
function getBlackFriday(year) {
  const novFirst = new Date(year, 10, 1); // November 1
  let fridayCount = 0;
  let date = new Date(novFirst);

  while (fridayCount < 4) {
    if (date.getDay() === 5) {
      fridayCount++;
      if (fridayCount === 4) break;
    }
    date.setDate(date.getDate() + 1);
  }
  return date;
}

const BlackFridayCountdown = () => {
  const theme = useTheme();

  const [timeLeft, setTimeLeft] = useState(null);
  const [isToday, setIsToday] = useState(false);
  const [targetDate, setTargetDate] = useState(null);

  useEffect(() => {
    const updateCountdown = () => {
      // Current time in California
      const now = new Date(
        formatInTimeZone(new Date(), TIMEZONE, "yyyy-MM-dd HH:mm:ss")
      );

      let bf = getBlackFriday(now.getFullYear());

      // If already passed this year, move to next year
      if (now > bf) {
        bf = getBlackFriday(now.getFullYear() + 1);
      }

      setTargetDate(bf);

      const isSameDay =
        now.getFullYear() === bf.getFullYear() &&
        now.getMonth() === bf.getMonth() &&
        now.getDate() === bf.getDate();

      setIsToday(isSameDay);

      if (!isSameDay) {
        const diff = differenceInSeconds(bf, now);
        const days = Math.floor(diff / (3600 * 24));
        const hours = Math.floor((diff % (3600 * 24)) / 3600);
        const minutes = Math.floor((diff % 3600) / 60);
        const seconds = diff % 60;
        setTimeLeft({ days, hours, minutes, seconds });
      }
    };

    updateCountdown();
    const interval = setInterval(updateCountdown, 1000);
    return () => clearInterval(interval);
  }, []);

  return (
    <Paper
      elevation={6}
      sx={{
        p: 2,
        mt: 2,
        mb: 2,
        textAlign: "center",
        borderRadius: "15px",
        background: isToday
          ? `linear-gradient(135deg, ${theme.palette.error.light}, ${theme.palette.error.main})`
          : `linear-gradient(135deg, ${theme.palette.primary.light}, ${theme.palette.secondary.light})`,
        color: theme.palette.getContrastText(theme.palette.primary.main),
        opacity: 0.90,
      }}
    >
      {isToday ? (
        <Typography variant="h5" sx={{ fontWeight: "bold" }}>
          TODAY IS BLACK FRIDAY! GET YOUR BFGBCS!!
        </Typography>
      ) : (
        <>
          {timeLeft && (
            <Typography variant="h6">
              {timeLeft.days}d {timeLeft.hours}h {timeLeft.minutes}m{" "}
              {timeLeft.seconds}s until Black Friday (
              {targetDate?.toLocaleDateString("en-US", {
                month: "long",
                day: "numeric",
                year: "numeric",
                timeZone: TIMEZONE,
              })}
              )
            </Typography>
          )}
        </>
      )}
    </Paper>
  );
}

export default BlackFridayCountdown